import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import comgif from "../Images/comgif.gif";
import sg from "../Images/sg.png";
import ic from "../Images/ic.jpg";
import rc1 from "../Images/rc1.png";
import ind from "../Images/ind.jpeg";
import cst from "../Images/cst.jpg";
import i5 from "../Images/i5.jpeg";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";

export default function Computer() {
  return (
    <>
      <SEO
        title="AI ERP & CRM for IT & Computer Industry"
        description="Scale IT services, software development, and tech enterprises with EnteliPro AI ERP software and intelligent client relationship management tools."
        keywords="IT ERP Software, Computer Industry CRM, Tech Enterprise Software, Software Company ERP, IT Service Management CRM"
        canonical="https://www.entelipro.com/Computer"
        ogImage="https://www.entelipro.com/static/media/comgif.gif"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Computer Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={comgif} alt="EnteliPro AI ERP for Computer and IT Industry" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  AI ERP Software for Computer & IT Industry
                </h1>
                <p className="para">
                  The computer and IT industry powers almost every modern sector.
                  From software engineering and cloud infrastructure to hardware maintenance
                  and client services, EnteliPro provides specialized AI-driven ERP and CRM solutions.
                </p>
                <div className="jst-two-coloums">
                  <div className="icon-text">
                    <p className="para">
                      Streamline developer workloads, sprint milestones, client ticketing,
                      and software licensing renewals seamlessly.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      Unified billing and resource planning enable IT service providers to track project
                      profitability and deliver predictable milestones.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies computer-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Grow Your IT Company Scientifically</h3>
              <p className="para">
                Computer software, hardware, and IT consultancy businesses face rapid tech shifts.
                EnteliPro AI ERP gives IT executives the business intelligence required to maximize billable hours and retain high-value enterprise accounts.
              </p>
            </div>
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Sustainable Growth</h4>
                  <Link to="/stablegrowth">
                    <img className="img-responsive" src={sg} alt="EnteliPro Sustainable IT Business Growth" />
                  </Link>
                  <p className="para">
                    {`${project_name}`} helps scale your technology business sustainably across domestic and international markets.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Improved Communication</h4>
                  <Link to="/improvedcommunication">
                    <img className="img-responsive" src={ic} alt="EnteliPro IT Stakeholder Communication" />
                  </Link>
                  <br />
                  <p className="para">
                    Enable clients, engineers, project managers, and partners to communicate faster with centralized message hubs.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Resource Management</h4>
                  <Link to="/resources">
                    <img className="img-responsive" src={rc1} alt="EnteliPro IT Resource and Talent Management" />
                  </Link>
                  <p className="para">
                    Allocate developer hours, plan hardware budgets, and track project burn rates with predictive resource modeling.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies computer-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Feedback and Referrals</h4>
                  <Link to="/survey">
                    <img className="img-responsive" src={ind} alt="EnteliPro Client Feedback and CSAT Surveys" />
                  </Link>
                  <p className="para">
                    Collect client feedback after sprint deliveries to elevate NPS scores and generate high-converting enterprise referrals.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Customer Support Tool</h4>
                  <Link to="/contact_us">
                    <img className="img-responsive" src={cst} alt="EnteliPro IT Helpdesk and Ticket Management" />
                  </Link>
                  <p className="para">
                    Resolve technical support tickets faster with integrated SLA tracking and multi-tier escalation pipelines.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Intelligent Dashboard</h4>
                  <Link to="/dashboardandreporting">
                    <img className="img-responsive" src={i5} alt="EnteliPro IT Business Intelligence Dashboard" />
                  </Link>
                  <p className="para">
                    Track recurring subscription revenue, sprint velocity, and engineer utilization rates in one intuitive dashboard.
                  </p>
                  <br />
                  <br />
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies computer-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Services of {`${project_name}`} for Your IT Industry</h3>
              <p className="para">
                Modern IT enterprises need agile, cloud-native ERP solutions that adapt to fast iteration cycles.
                Replace legacy, disconnected tools with EnteliPro to unify your project management, billing, client contracts, and talent management.
              </p>
              <Link
                to="/customer_services"
                className="btn action-button mt-lg-5 mt-4 "
              >
                Explore Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}